module.exports = __webpack_public_path__ + "static/media/flag-ar.a6a37d37.svg";